import React from 'react'

import { Button, ButtonProps } from '../Button'

export interface InputButtonProps extends ButtonProps {}

export const InputButton = ({ ...restProps }: InputButtonProps) => {
  return (
    <Button
      h="1.75rem"
      size="sm"
      borderRadius="md"
      variantColor="green"
      fontFamily="heading"
      fontSize="sm"
      hasDepth={false}
      {...restProps}
    />
  )
}

export default InputButton
